module.exports = __webpack_public_path__ + "img/logo.5dc111fb.svg";